module.exports = __webpack_public_path__ + "media/images/icon/arrow-circle-right-4638fe26afff6e2821f136f829945e4b.svg";